import React from "react";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as categoryRedux from "modules/Category/_redux/categoryRedux";
import "./sahibindenFilters.css";

// Sahibinden tarzı metrekare aralığı: sade min/max input.
// selectedFilter.minMaxM2 = [min, max]; backend plugin'i seller m2 field'ı
// üzerinde { $gte, $lte } ile uygular (km/year ile aynı konvansiyon).
function SLMinMaxM2(props) {
  const { selectedFilter } = useSelector(
    (state) => ({ selectedFilter: state.category.selectedFilter }),
    shallowEqual
  );

  const value = selectedFilter?.minMaxM2 || ["", ""];
  const [min, max] = value;

  const setRange = (nextMin, nextMax) => {
    const empty =
      (nextMin === "" || nextMin === null || nextMin === undefined) &&
      (nextMax === "" || nextMax === null || nextMax === undefined);
    if (empty) {
      props.removeFilter({ parent: "minMaxM2" });
      return;
    }
    props.addFilterBulk({ parent: "minMaxM2", value: [nextMin, nextMax] });
  };

  return (
    <section id={props.filter.id} className="sf-section">
      <div className="sf-title">{props.filter.title || "m²"}</div>
      <div className="sf-minmax">
        <input
          className="sf-input"
          type="number"
          placeholder="min m²"
          value={min == null ? "" : min}
          onChange={(e) =>
            setRange(e.target.value === "" ? "" : Number(e.target.value), max)
          }
        />
        <span className="sf-dash">–</span>
        <input
          className="sf-input"
          type="number"
          placeholder="max m²"
          value={max == null ? "" : max}
          onChange={(e) =>
            setRange(min, e.target.value === "" ? "" : Number(e.target.value))
          }
        />
      </div>
    </section>
  );
}

export default connect(null, { ...categoryRedux.actions })(SLMinMaxM2);
